import Slider from 'react-slick';

import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { CaretLeft, CaretRight } from '@phosphor-icons/react';

import BackgroundBanner from 'src/assets/image/bg-home-banner.png';
import BackgroundBanner2 from 'src/assets/image/bg-home-banner-2.jpg';
import BackgroundBanner3 from 'src/assets/image/bg-home-banner-3.jpg';
import BackgroundBanner4 from 'src/assets/image/bg-home-banner-4.jpg';
import BackgroundBanner5 from 'src/assets/image/bg-home-banner-5.jpg';
import BackgroundBanner6 from 'src/assets/image/bg-home-banner-6.jpg';
import IconLogoSmallWhite from 'src/assets/image/ic-logo-s-white.svg';

import ImageComponent from 'src/component/core/image';

export default function Banner() {

    const { t } = useTranslation();

    const refContainer = useRef();

    const settingsContainer = {
        arrows: false,
        autoplay: true,
        autoplaySpeed: 5000,
        cssEase: "linear",
        infinite: true,
        slidesToScroll: 1,
        slidesToShow: 1,
        speed: 300,
    };

    return (
        <div className='relative w-full z-[1]'>
            <Slider ref={refContainer} {...settingsContainer}>
                <div className='relative w-full'>
                    <div className='absolute h-[600px] left-0 overflow-hidden top-0 z-[0] w-full'>
                        <ImageComponent src={BackgroundBanner} alt='Banner' className='absolute h-full left-0 object-cover top-0 w-full' />
                        <div className='absolute bg-black/60 h-full left-0 top-0 w-full z-[1]'></div>
                        <ImageComponent src={IconLogoSmallWhite} alt='Logo' className='absolute left-1/2 pb-48 opacity-40 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[1]' height={254} width={254} />
                    </div>
                    <div className='flex gap-12 h-[600px] items-center max-w-[1280px] mx-auto px-6 relative w-full z-[1]'>
                        <div className='flex flex-col gap-3 mx-auto px-8 relative w-full lg:px-20'>
                            <h1 className='font-black text-center text-white'>{t("NATURETRUST VERIFIKATOR INDONESIA")}</h1>
                            <div className='bg-white h-1 mx-auto rounded-lg w-full xs:w-[400px]'></div>
                            <h6 className='font-semibold text-center text-white'>&quot;{t("Your trusted partner for certification, validation and verification of Environmental Project")}&quot;</h6>
                        </div>
                    </div>
                </div>
                {/* <div className='relative w-full'>
                    <div className='absolute h-[600px] left-0 overflow-hidden top-0 z-[0] w-full'>
                        <ImageComponent src={BackgroundBanner2} alt='Banner 2' className='absolute h-full left-0 object-cover top-0 w-full' />
                        <div className='absolute bg-black/60 h-full left-0 top-0 w-full z-[1]'></div>
                    </div>
                    <div className='flex gap-12 h-[600px] items-center max-w-[1280px] mx-auto px-6 relative w-full z-[1]'>
                        <div className='flex flex-col gap-3 mx-auto px-8 relative w-full lg:px-20'>
                            <h1 className='font-black text-center text-white'>{t("CARBON AND BIOMASS CERTIFICATION")}</h1>
                            <div className='bg-white h-1 mx-auto rounded-lg w-full xs:w-[400px]'></div>
                            <h6 className='font-semibold text-center text-white'>{t("We evaluate compliance with biomass and carbon certification requirements")}</h6>
                        </div>
                    </div>
                </div> */}
                <div className='relative w-full'>
                    <div className='absolute h-[600px] left-0 overflow-hidden top-0 z-[0] w-full'>
                        <ImageComponent src={BackgroundBanner3} alt='Banner 3' className='absolute h-full left-0 object-cover top-0 w-full' />
                        <div className='absolute bg-black/60 h-full left-0 top-0 w-full z-[1]'></div>
                    </div>
                    <div className='flex gap-12 h-[600px] items-center max-w-[1280px] mx-auto px-6 relative w-full z-[1]'>
                        <div className='flex flex-col gap-3 mx-auto px-8 relative w-full lg:px-20'>
                            <h1 className='font-black text-center text-white'>{t("VERIFICATION/VALIDATION CONFORMITY")}</h1>
                            <div className='bg-white h-1 mx-auto rounded-lg w-full xs:w-[400px]'></div>
                            <h6 className='font-semibold text-center text-white'>{t("NatureTrust's GHG validation and/or verification conformity assessments are based on the validation and verification activity standards SNI ISO/IEC 17029:2019 and SNI ISO 14065:2020")}</h6>
                        </div>
                    </div>
                </div>
                <div className='relative w-full'>
                    <div className='absolute h-[600px] left-0 overflow-hidden top-0 z-[0] w-full'>
                        <ImageComponent src={BackgroundBanner4} alt='Banner 4' className='absolute h-full left-0 object-cover top-0 w-full' />
                        <div className='absolute bg-black/60 h-full left-0 top-0 w-full z-[1]'></div>
                    </div>
                    <div className='flex gap-12 h-[600px] items-center max-w-[1280px] mx-auto px-6 relative w-full z-[1]'>
                        <div className='flex flex-col gap-3 mx-auto px-8 relative w-full lg:px-20'>
                            <h1 className='font-black text-center text-white'>{t("VISION")}</h1>
                            <div className='bg-white h-1 mx-auto rounded-lg w-full xs:w-[100px]'></div>
                            <h6 className='font-semibold text-center text-white'>&quot;{t("To be the leading one-stop provider of certification, validation, and verification services across Indonesia")}&quot;</h6>
                        </div>
                    </div>
                </div>
                <div className='relative w-full'>
                    <div className='absolute h-[600px] left-0 overflow-hidden top-0 z-[0] w-full'>
                        <ImageComponent src={BackgroundBanner5} alt='Banner 5' className='absolute h-full left-0 object-cover top-0 w-full' />
                        <div className='absolute bg-black/60 h-full left-0 top-0 w-full z-[1]'></div>
                    </div>
                    <div className='flex gap-12 h-[600px] items-center max-w-[1280px] mx-auto px-6 relative w-full z-[1]'>
                        <div className='flex flex-col gap-3 mx-auto px-8 relative w-full lg:px-20'>
                            <h1 className='font-black text-center text-white'>{t("MISSION")}</h1>
                            <div className='bg-white h-1 mx-auto rounded-lg w-full xs:w-[100px]'></div>
                            <h6 className='font-semibold text-center text-white'>{t("Our objective is to support organizations, project developers, managers, and communities on their journey toward environmental responsibility")}</h6>
                        </div>
                    </div>
                </div>
                <div className='relative w-full'>
                    <div className='absolute h-[600px] left-0 overflow-hidden top-0 z-[0] w-full'>
                        <ImageComponent src={BackgroundBanner6} alt='Banner 6' className='absolute h-full left-0 object-cover top-0 w-full' />
                        <div className='absolute bg-black/60 h-full left-0 top-0 w-full z-[1]'></div>
                    </div>
                    <div className='flex gap-12 h-[600px] items-center max-w-[1280px] mx-auto px-6 relative w-full z-[1]'>
                        <div className='flex flex-col gap-3 mx-auto px-8 relative w-full lg:px-20'>
                            <h1 className='font-black text-center text-white'>{t("OUR COMMITMENT")}</h1>
                            <div className='bg-white h-1 mx-auto rounded-lg w-full xs:w-[100px]'></div>
                            <h6 className='font-semibold text-center text-white'>{t("More than a service provider, we are a partner — offering guidance grounded in diligence, expertise, and an unwavering commitment to a sustainable future")}</h6>
                        </div>
                    </div>
                </div>
            </Slider>
            <CaretLeft color='#FFFFFF' className='absolute cursor-pointer left-2 top-1/2 text-4xl -translate-y-1/2 lg:text-[92px]' onClick={() => refContainer?.current?.slickPrev()} />
            <CaretRight color='#FFFFFF' className='absolute cursor-pointer right-2 top-1/2 text-4xl -translate-y-1/2 lg:text-[92px]' onClick={() => refContainer?.current?.slickNext()} />
        </div>
    );
}
